import { Policy } from 'shared';
import { EmployeeRole } from './types/employee-role';
import { IEmployeePolicyRoles } from './types/i-employee-policy-roles';

export const AppEmployeePolicyRoles: IEmployeePolicyRoles[] = [
    {
        policy: Policy.ApproveMarkupCheckout,
        roles: [EmployeeRole.Employee, EmployeeRole.Leader],
    },
    {
        policy: Policy.InspectMarkupOrder,
        roles: [EmployeeRole.Leader],
    },
    {
        policy: Policy.AccessOrderReturn,
        roles: [EmployeeRole.Leader],
    },
    {
        policy: Policy.StartOrderReturn,
        roles: [EmployeeRole.Leader],
    },
];
